import React, { useState } from "react";
import { useSelector } from "react-redux";
import Cookies from "universal-cookie";
import { DocumentCheckIcon, CheckCircleIcon, ExclamationCircleIcon, ArrowDownCircleIcon } from "@heroicons/react/24/outline";
import Container from "../components-layout/Container";
import Layout from "../Layout";
import WarningModal from "../components-modals/WarningModal";
import Header from "../components-layout/Header";
import { fetchApi } from "../tools";

import FiltrosIndex from "../c&m/bodegas/revision_bodega/components/FiltrosIndex";
import { PDFDownloadLink } from "@react-pdf/renderer";
import RevisionExistenciaPDF from "../c&m/bodegas/revision_bodega/pdf/RevisionExistenciaPDF";
import GridInventarioStockSede from "./components/GridInventarioStockSede"; 

const InventarioStockSedeIndex = () => {
    const [filterData, setFilter] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 1;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const nPages = Math.ceil(filterData?.length / recordsPerPage);
    const cookies = new Cookies();
    const user = useSelector((state) => state.auth.user);
    const IdBodega = useSelector((state) => state.auth.bodegas[0].IdBodega)
    const sede1 = useSelector( (state) => state.auth.bodegas[0].NombreBodega )
    const IdEmp = useSelector((state) => state.auth.IdEmp)
  
    const [bodega, setBodega] = useState(IdBodega);
    const [pdfInventario, setPDFInventario] = useState([
      {
        "Cantidad": 0,
        "Equipo": 0,
        "Sede": 0,
      }
    ]);
    const [sedeSeleccionada, setSedeSeleccionada] = useState("");
    const [descargarVisible, setDescargarVisible] = useState(false);
    const [month, setMonth] = useState("");
    const [textHabilitados, setTextHabilitados] = useState(false);
    const [rawData] = useState([]);

    const [textos, setTextos] = useState([])
    const bodegaAsignada = useSelector((state) => state.auth.bodegas.IdBodega);
    const url = cookies.get("__urlInvoiceApi"); // url para enviar al api viene de cookies
    const IdSede = useSelector((state) => state.auth.IdSede);
    const { headersAPI: headers } = useSelector((state) => state.url);
    const userObj = JSON.parse(user);
    const [busquedaInvisible, setBusquedaInvisible] = useState(true)
    const [sede, setSede] = useState(sede1)
    const [idEmpBodega, setIdEmpBodega] = useState("")
    const [empleados, setEmpleados] = useState([])
  
  
    const [sedes, setSedes] = useState([]);
    const [modal, setModal] = useState({
      ok: false,
      msg: "",
      show: false,
    });

    const handleOption = (e) => {
        if(e.target.value === "0"){
          setBusquedaInvisible(true)
          setPDFInventario([])
        }else{
          setBusquedaInvisible(false)
          setBodega(parseInt(e.target.value));
          bodegasEmp(parseInt(e.target.value))
        }
      };

      const bodegasEmp = async(bodegaSeleccionada) => {
        let arrIdEmps = []
        const response = await fetchApi({
          url: url + '/utils/busquedas',
          headers:headers,
          content:{
            "opcion":"BODEGASEMP",
            "IdBodega":bodegaSeleccionada
          }
        })
        response.msg.forEach(element => {
          arrIdEmps.push(element.IdEmp)
        })
        setSede(response.msg[0].Campus)
        const empBodega = (arrIdEmps.toString().replaceAll(',','|'))
        setIdEmpBodega(empBodega)
      }
      const handleBuscar = () => {
    
        if(bodega === 0){
          setPDFInventario([])
        }else{
          getData();
          setDescargarVisible(true);
        }
      };
      const handleDate = (e) => {
        setMonth(e.target.value);
      };

      const getData = async () => {
        const response = await fetchApi({
          url: url + "/vistas/inventario",
          headers: headers,
          content: {
            Opcion: "INVENTARIO",
            IdBodega: bodega,
          },
        });
        
        setPDFInventario(unicos(response.msg));
        setSedeSeleccionada(response.msg[0].Campus);
      };

      const unicos = (array) => {
        let dataOriginal = array;
        dataOriginal.map((elemento, index) => {
          elemento.Faltante = 0;
          elemento.Sobrante = 0;
          elemento.TotalFaltante = 0;
        });
        let hash = {};
        return dataOriginal.filter((o) =>
          hash[o.IdProducto] ? false : (hash[o.IdProducto] = true)
        );
      }

      const handleGridInput = (e, Idx) => {
      };

      const handleChangeTextbox = (e, Idx) => {
        setTextos({
          ...textos,
          [e.target.name]: parseInt(e.target.value || 0),
        });
      };

  return (
    <>
      <Layout userObj={userObj} activeTab="Bodegas">
        <WarningModal
          open={modal.show ? true : false}
          image={
            modal.ok ? (
              <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
            ) : (
              <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto" />
            )
          }
          title="Aviso"
          subtitle={<span>{modal.msg}</span>}
          opacity="bg-opacity-50"
        >
          <div className="mt-5 sm:mt-6">
            <button
              onClick={() => {
                if (modal.reload) {
                  window.location.reload();
                }
                setModal((curr) => ({
                  ...curr,
                  show: false,
                  reload: false,
                }));
              }}
              type="button"
              className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
              >
              Entendido
            </button>
          </div>
            
        </WarningModal>
        <Container height="h-full">
          <Header title="Inventario de stock sede" logo={DocumentCheckIcon} />
          <div className={"shadow-white shadow-sm  rounded-md"}>
            {/* Componentes */}
            <div className={"p-2"}>
              <FiltrosIndex
                busquedaInvisible={busquedaInvisible}
                fetchApi={fetchApi}
                url={url}
                headers={headers}
                bodegaAsignada={bodegaAsignada}
                handleOption={handleOption}
                handleBuscar={handleBuscar}
                handleDate={handleDate}
                month={month}
                empleados={empleados}
                //setIdEmp={setIdEmp}
                IdBodega={IdBodega}
              />
            </div>
            
            <div
              className={"p-4"} // shadow-sm shadow-white rounded-md w-full h-full flex flex-row
            >
              {true && (
                <div className={"flex flex-row w-full justify-end m-2"}>
                  <PDFDownloadLink
                  fileName={"Revisión_existencia"}
                    className=" inline-flex justify-center rounded-md border border-transparent bg-secundario py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-secundario hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
                    document={
                      <RevisionExistenciaPDF
                        sede={sede}
                        data={pdfInventario}
                        sedeSeleccionada={sedeSeleccionada}
                      />
                    }
                  >
                    <div className="flex">
                      <ArrowDownCircleIcon
                        className="h-5 w-5 text-white"
                        aria-hidden="true"
                      />
                      <p className="ml-1">
                        Descargar PDF para verificar existencia
                      </p>
                    </div>
                  </PDFDownloadLink>
                </div>
              )}
            </div>
            {
                pdfInventario.length > 0 &&
            <div className={"w-full "}>
                <GridInventarioStockSede
                filteredData={pdfInventario}
                handleGridInput={handleGridInput}
                handleChangeTextbox={handleChangeTextbox}
                textHabilitados={textHabilitados}
                />
            </div>
             }
          </div>
        </Container>
      </Layout>
    </>
  )
}

export default InventarioStockSedeIndex